import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import { PRIMARY_LANG } from "Common/constant";
import service from '../../utils/service';
import { baseUrlObj } from "Common/Json";

// my-profile v2.0.0 sends care_plans (a list) instead of one care_plan; the active plan is
// flattened into user_details the same way care_plan was (plan_name, plan_expiry_date, ...)
const getCarePlan = (data) =>
  data?.care_plan || data?.care_plans?.find((plan) => plan?.is_plan_active) || data?.care_plans?.[0] || {};

export const initialState = {
  loading: false,
  user_details: { role: "Guest", baseUrl: "/guest-user" },
  account_details: { role: "Guest", baseUrl: "/guest-user" },
  user_details_error: {},
  account_details_error: {},
  token: {},
  signupPage:false,
  signupStepper : 0,
  upComingPath:"",
  recentRoutes:"",
  networkError : false,
  tzValidated: false,
  guest_uuid:"",
  includePrimeLang: false,
  isRoleSelected: false,
  isMultipleRolePresent: false,
  isCampaignFlow : false,
  campaignData : null,
  login_with:"",
  selectedClinicianList: {},
  doctorSelectedData: {},
  doctorID : "",
  appointmentStepper : false,
  isChatOpened:false,
  language_payload_uuid:"",
  activeCarePlan:null,
};
const loginReducer = createSlice({
  name: "login",
  initialState,
  reducers: {
    loginAccessToken(state, { payload }) {
      state.user_details = { ...state.user_details, access_token: payload };
    },
    ssoLoginAccessToken(state, { payload }) {
      state.account_details = payload || state.account_details;
      state.account_details_error = {};
      state.user_details = payload || state.user_details;
      state.user_details_error = {};
    },
    accountAccessToken(state, { payload }) {
      state.account_details = { ...state.account_details, access_token: payload };
    },
    accountDetailsUpdate(state, { payload }) {
      state.account_details = { ...state.account_details, ...payload };
    },
    setBaseUrl(state, action) {
      let { user_details } = state;
      if (user_details) {
        let { is_appointment_booked = false, is_membership_active = false, is_membership_expired = false, membership_expiry_date, membership_type = "", is_socio_demographic = false, is_evaluated = '', is_membership_benefits_availed= '', membership_benefits_availed_date ='', display_plan_name="" } = user_details || {};
        localStorage.setItem("subscription", JSON.stringify({ is_evaluated, is_appointment_booked, is_membership_active, is_membership_expired, membership_expiry_date, membership_type, is_socio_demographic, is_membership_benefits_availed, membership_benefits_availed_date, display_plan_name }))
        user_details.baseUrl = action.payload;
      }

      let finalObj = { ...state, user_details }
      Object.assign(state, finalObj)
    },
    setSubScribeData(state, action) {
      let { user_details } = state;
      if (user_details)
        user_details.is_subscribed = action.payload;
      let finalObj = { ...state, user_details }
      Object.assign(state, finalObj)
    },
    setEvaluationData(state, action) {
      let { user_details } = state;
      if (user_details)
        user_details.is_evaluation_eligible = action.payload;
      let finalObj = { ...state, user_details }
      Object.assign(state, finalObj)
    },
    setIsSocioData(state, action) {
      let { user_details } = state;
      if (user_details)
        user_details.is_socio_demographic = action.payload;
      let finalObj = { ...state, user_details }
      Object.assign(state, finalObj)
    },
    setTimeZoneOffset(state, action) {
      let { user_details } = state;
      if (user_details)
        user_details.time_zone_offset_in_min = action.payload;
      let finalObj = { ...state, user_details }
      Object.assign(state, finalObj)
    },
    signUpPage(state, action){
      state.signupPage = action.payload;
    },
    refreshLoginAccessToken(state, { payload }) {
      // state.account_details = { ...state.account_details,...payload };
      state.user_details = { ...state.user_details,...payload };
    },
    refreshAccountLoginAccessToken(state, { payload }) {
      state.account_details = { ...state.account_details,...payload };
      // state.user_details = { ...state.user_details,...payload };
    },
    signUpStepper(state, action){
      state.signupStepper = action.payload;
    },
    upComingPath(state, action){
      state.upComingPath = action.payload;
    },
    recentRoutes(state, action){
      state.recentRoutes = action.payload;
    },
    setNetworkDrop(state, { payload }) {
      state.networkError = payload;
    },
    setTZValidated(state, { payload }) {
      state.tzValidated = payload;
    },
    setLanguage(state, { payload }) {
      state.includePrimeLang = payload.includePrimeLang;
      state.user_details = { ...state.user_details, language: payload.language };
    },
    setLanguageUuid(state,  {payload }) {
      state.language_payload_uuid  = payload;      
    },
    setActivePlan(state,  {payload }) {
      state.activeCarePlan = payload;      
    },
    setGuestUUID(state, { payload }) {
      state.guest_uuid = payload;
    },
    setLoginWith(state, {payload}){
      state.login_with=payload;
    },
    setDoctorSelectedData(state, {payload}){
      state.doctorSelectedData= payload.doctorSelectedData || {};
      state.doctorID= payload.doctorID || "";
      state.appointmentStepper = payload?.appointmentStepper || false;
    },
    setRoleSelected(state, { payload }) {
      state.isRoleSelected = payload.isRoleSelected;
      state.user_details = {
        ...state.user_details,
        role: payload.role,
      };
    },
    setCampaignData(state, { payload }) {
      state.isCampaignFlow = payload.isCampaignFlow;
      state.campaignData = payload.campaignData;
    },
    setMultipleRolePresent(state, { payload }) {
      state.isMultipleRolePresent = payload.isMultipleRolePresent;
    },
    setDoctorDetailId(state, {payload}){
      state.doctorDetailId = payload.doctorId;
    },
    setPathways(state, { payload }) {
      if (payload.pathways) {
        state.user_details = {
          ...state.user_details,
          currentStep : payload.currentStep,
          pathways: payload.pathways,
        };
      } else {
        state.user_details = {
          ...state.user_details,
          currentStep: payload.currentStep,
          pathways: current(state.user_details.pathways).map((item) =>
            item.page === payload.completedStep?.page
              ? { ...item, ...payload.completedStep}
              : item
          ),
        };
      }
    },
    setProfileCompleted(state, { payload }) { 
      state.user_details = {
        ...state.user_details,
        is_profile_completed: payload.is_profile_completed,
      };
    },
    setPlans(state, { payload }) {
      state.user_details = {
        ...state.user_details,
        is_own_plan: payload.is_own_plan,
        is_niyama_plan: payload.is_niyama_plan,
      };
    },
    setB2BSelectedDoctor(state, {payload}){
      state.user_details={
        ...state.user_details,
        selectedClinician: payload.selectedClinicianList,
        // selected_doctor: 
      }      
  },
  setProfilePicture(state, action){
    state.user_details={
      ...state.user_details, profile_picture: action.payload }      
},
  setIsChatOpened(state, { payload }) {
    state.isChatOpened = payload;
  },
  },
  extraReducers: (builder) => {
    builder
      .addCase("login/getData/fulfilled", (state, { payload }) => {
        state.user_details = payload?.data || state.user_details;
        state.user_details_error = {};
        state.loading = false;
      })
      .addCase("login/getProfileDetails/fulfilled", (state, { payload }) => {
        state.user_details = payload?.data || state.user_details;
        state.user_details_error = {};
        state.loading = false;
      })
      .addCase("login/getMyProfileDetails/fulfilled", (state, { payload }) => {
        state.user_details = payload?.data || state.user_details;
        state.user_details_error = {};
        state.loading = false;
      })
      .addCase("otp-login/otp-getData/fulfilled", (state, { payload }) => {
        state.user_details = payload?.data || state.user_details;
        state.user_details_error = {};
        state.loading = false;
      })
      .addCase("login/getAccountData/fulfilled", (state, { payload }) => {
        state.account_details = payload?.data || state.account_details;
        state.account_details_error = {};
        state.user_details = payload?.data || state.user_details;
        state.user_details_error = {};
        state.loading = false;
      })
      .addCase("login/getStatus/fulfilled", (state, { payload }) => {
        let login_data = ""; 
        if(payload?.data?.profile?.relationship){
          let baseObj = { ...payload?.data };
          ['profile', 'time_zone', 'demographic', 'organisation', 'care_plan', 'profile_status'].forEach(key => delete baseObj[key]);
          login_data = {
            ...baseObj,
            role: "patient",
            user_id: payload?.data.profile.profile_id, // API UPDATE required
            pathways: [...payload?.data.profile_status],
            language: payload.data.profile.language_type,
            ...['profile', 'time_zone', 'demographic', 'organisation'].reduce((acc, key) => ({ ...acc, ...payload?.data[key] }), {}),
            ...getCarePlan(payload?.data),
          }
          state.user_details = payload?.data ? { access_token : state.user_details?.access_token, refresh_token : state.user_details?.refresh_token, ...login_data } : state.user_details;
        }else{ 
          login_data = payload?.data;
          state.user_details = payload?.data ? { access_token : state.account_details?.access_token, refresh_token : state.account_details?.refresh_token, ...login_data } : state.account_details;
        }
        state.account_details = payload?.data ? { access_token : state.account_details?.access_token, refresh_token : state.account_details?.refresh_token, ...login_data } : state.account_details;
        state.account_details_error = {};
        
        state.user_details_error = {};
        state.loading = false;
      })
      .addCase("login/getData/pending", (state, action) => {
        state.loading = true;
      })
      .addCase("otp-login/otp-getData/pending", (state, action) => {
        state.loading = true;
      })
      .addCase("login/getAccountData/pending", (state, action) => {
        state.loading = true;
      })
      .addCase("login/getStatus/pending", (state, action) => {
        state.loading = true;
      })
      .addMatcher(
        (action) => action.type.endsWith("/rejected"),
        (state, { payload }) => {
          state.user_details = {};
          state.user_details_error = payload;
          state.loading = false;
        })

  },
});
export const { setBaseUrl, loginAccessToken, setSubScribeData, setEvaluationData, setIsSocioData, signUpPage,refreshLoginAccessToken,refreshAccountLoginAccessToken, signUpStepper , accountAccessToken,upComingPath,recentRoutes,  setNetworkDrop, setIsChatOpened, setTZValidated, setLanguage,setLanguageUuid,setActivePlan ,setGuestUUID, setTimeZoneOffset, accountDetailsUpdate, setRoleSelected, setCampaignData,setMultipleRolePresent,setLoginWith, setDoctorDetailId, setPathways, setProfileCompleted,setAssmtCompleted, setPlans, setB2BSelectedDoctor, setDoctorSelectedData,setProfilePicture,ssoLoginAccessToken} = loginReducer.actions;

export const getLoginData = createAsyncThunk(
  "login/getData",
  async ({ url, data }, thunkAPI) => {
    try {
      // const source = axios.CancelToken.source();
      // thunkAPI.signal.addEventListener("abort", () => {
      //   source.cancel();
      // });
      // const response = await axios.post(url, sendData, {
      //   cancelToken: source.token,
      // });
      const response = await service.post(url, data);
      return response?.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const getProfileDetails = createAsyncThunk(
  "login/getProfileDetails",
  async ({ url, data }, thunkAPI) => {
    try {
      const response = await service.post(url, data);
      let baseObj = { ...response.data.data };
      ['token','profile_status'].forEach(key => delete baseObj[key]);
      response.data.data = {
        ...baseObj,
        role : "patient",
        user_id : data.profile_id,
        pathways : [...response.data.data.profile_status],
        ...['token'].reduce((acc, key) => ({ ...acc, ...response.data.data[key] }), {})
      }
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const getMyProfileDetails = createAsyncThunk(
  "login/getMyProfileDetails",
  async ({ url, token }, thunkAPI) => {
    try {
      const response = await service.get(url);
      response.data.data = {...response.data.data , "token":{...token}}
      let baseObj = { ...response.data.data };
      ['profile','token', 'time_zone', 'demographic', 'organisation', 'care_plan','profile_status'].forEach(key => delete baseObj[key]);      
      response.data.data = {
        ...baseObj,
        baseUrl :baseUrlObj["patient"],
        role : "patient",
        user_id : response.data.data?.profile?.profile_id || "12341234",
        pathways : [...response.data.data.profile_status],
        language: response.data.data.profile.language_type,
        ...['profile','token', 'time_zone', 'demographic', 'organisation'].reduce((acc, key) => ({ ...acc, ...response.data.data[key] }), {}),
        ...getCarePlan(response.data.data),
      }
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const getAccountData = createAsyncThunk(
  "login/getAccountData",
  async ({ url, data }, thunkAPI) => {
    try {
      const response = await service.post(url, data);
      return response?.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const getOtpLoginData = createAsyncThunk(
  "otp-login/otp-getData",
  async ({ url, data }, thunkAPI) => {
    try {
      // const source = axios.CancelToken.source();
      // thunkAPI.signal.addEventListener("abort", () => {
      //   source.cancel();
      // });
      // const response = await axios.post(url, sendData, {
      //   cancelToken: source.token,
      // });
      const response = await service.post(url, data);
      return response?.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const getStatus = createAsyncThunk(
  "login/getStatus",
  async ({ url, data, role }, thunkAPI) => {
    try {
      let response = await service.get(url, data);
      let updated_response = response?.data;
      if(role== "patient"){
        updated_response.data["role"] = role;
        updated_response.data["name"] = updated_response.data.demographic["first_name"];
        updated_response.data["mobile_number"] = updated_response.data.demographic["mobile"];
      }else{
        updated_response.data.role = role;
      }
      updated_response.data["first_name"] = updated_response.data.name;
      return updated_response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export default loginReducer.reducer;
